import dispatcher from '../dispatcher';
import routerStore from '../router/router.store';

var name = 'underline-decorator';

if (!window._registeredDecorators) {
	window._registeredDecorators = [];
}
if (window._registeredDecorators.indexOf(name) !== -1) {
	console.warn('error. decorator with name "' + name + '" already registered');
	// return;
} else {
	window._registeredDecorators.push(name);
}

var _handleRouterStore = function() {
	var decorator = this._decorators[name];

	if (this.classList.contains('active')) {
		if (!decorator._currentBorder) {
			decorator.handleMouseenter(true);
		}
	} else {
		decorator.handleMouseleave(true);
	}
}

var _handleMouseenter = function(forsed) {
	var decorator = this._decorators[name];
	var b = document.createElement('div');

	if (!forsed && Modernizr.mobile) {
		return;
	}
	if (this.classList.contains('active') && !forsed) return;
	if (decorator._currentBorder) return;

	b.className = 'border';
	b.style.left = '-20px';
	if (window.navigator.userAgent.indexOf('Edge') > -1) {
		b.style.right = '100%';
	} else {
		b.style.right = 'calc(100% + 20px)';
	}


	this.appendChild(b);
	this.classList.add('hover');

	decorator._currentBorder = b;

	setTimeout(function() {
		b.style.right = 0;
		b.style.left = 0;
	}, 20);
}

var _handleMouseleave = function(forsed) {
	var decorator = this._decorators[name];
	var b = decorator._currentBorder;

	if (!forsed && Modernizr.mobile) return;
	if (this.classList.contains('active')) return;
	if (!decorator._currentBorder) return;

	decorator._currentBorder = null;
	this.classList.remove('hover');

	b.style.left = '100%';

	setTimeout(function() {
		b.parentNode.removeChild(b);
	}, 600);
}

var attach = function(component) {
	var decorator = {};

	if (!component._decorators) {
		component._decorators = {};
	}
	component._decorators[name] = decorator;

	// if (Modernizr.mobile) return;

	decorator.handleMouseenter = _handleMouseenter.bind(component);
	decorator.handleMouseleave = _handleMouseleave.bind(component);
	decorator.handleRouterStore = _handleRouterStore.bind(component);

	if (!Modernizr.mobile) {
		component.addEventListener('mouseenter', decorator.handleMouseenter);
		component.addEventListener('mouseleave', decorator.handleMouseleave);
	}

	decorator.handleRouterStore();
	routerStore.subscribe(decorator.handleRouterStore);
}

var detach = function(component) {
	var decorator = component._decorators[name];

	routerStore.unsubscribe(decorator.handleRouterStore);
}

export default {
	attach: attach,
	detach: detach
};